import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { PricePrice } from 'src/types';
import ShippingLabelComponent from 'src/components/shipping-label';
import { MediumUp } from './styles';

interface IShippingLabel {
  price?: PricePrice | null;
}

export const ShippingLabel: React.FC<IShippingLabel> = props => {
  const { price } = props;
  const { priceDisplay } = usePriceRowContext();

  if (!price) {
    return null;
  }

  return (
    <MediumUp>
      {price.exclShipping && (
        <BodySmallText>
          <ShippingLabelComponent
            toneDown
            exclShipping={price.exclShipping}
            inclShipping={price.inclShipping}
            priceDisplay={priceDisplay}
          />
        </BodySmallText>
      )}
    </MediumUp>
  );
};
